import {sendGAEvent} from '@next/third-parties/google';

// Fire a GA4 event via gtag. Production-only: the GA script loads in every
// environment (gated only on NEXT_PUBLIC_GA_ID, which is set everywhere), so we
// gate the events themselves to keep dev/staging traffic out of Analytics.
export function gaEvent(name: string, params: Record<string, unknown> = {}): void {
  if (process.env.NEXT_PUBLIC_IQ_ENVIRONMENT !== 'production') return;
  sendGAEvent('event', name, params);
}
